import React, { useEffect, useState } from 'react';
import { MapContainer as LeafletMap, TileLayer, Marker, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import Sucursal from "./Sucursal";
import L from 'leaflet'; // Importa Leaflet
import Cono from "./../img/MapContainer/cono.png"; // Importa el icono como una URL

const MapContainer = ({ addresses, handleScrollTo }) => {
  const [coordinates, setCoordinates] = useState([]);
  const [isLoading, setIsLoading] = useState(true); // Estado para manejar la carga

  // Función para obtener las coordenadas geográficas de una dirección utilizando la API de geolocalización
  const getCoordinates = async (address) => {
    try {
      const response = await fetch(`https://nominatim.openstreetmap.org/search?q=${address}&format=json`);
      const data = await response.json();
      if (data && data.length > 0) {
        return { lat: parseFloat(data[0].lat), lng: parseFloat(data[0].lon) };
      }
    } catch (error) {
      console.error('Error fetching coordinates:', error);
    }
    return null;
  };

  useEffect(() => {
    const loadCoordinates = async () => {
      const allCoordinates = await Promise.all(addresses.map(async (address) => {
        const coords = await getCoordinates(address.address);
        return { ...address, coords };
      }));
      setCoordinates(allCoordinates.filter(coord => coord.coords)); // Filtrar los nulos
      setIsLoading(false); // Cuando se termine de cargar, cambia el estado a falso
    };

    loadCoordinates();
  }, [addresses]);

  // Define el icono personalizado utilizando L.icon
  const customIcon = L.icon({
    iconUrl: Cono,
    iconSize: [32, 32], // Tamaño del icono
    iconAnchor: [16, 16], // Punto de anclaje del icono (centro)
  });

  return (
    <div style={{ height: '100%', width: '100%' }}>

      <LeafletMap center={[-34.7807, -55.6602]} zoom={9} style={{ height: '400px', width: '100%', border: 'solid 1px black',position: 'relative' }}>
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        />
              {isLoading && ( // Mostrar la capa semitransparente si está cargando
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.3)', // Fondo semitransparente
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column',
          zIndex: 1000 // Asegura que esté por encima del mapa
        }}>
          <h3 style={{ color: 'white', fontSize: '20px', fontWeight: 'bold' }}>Pronto verás donde degustar nuestros sabores.
          </h3>
          
          <p style={{ color: 'white', fontSize: '20px', fontWeight: 'bold' }}>Cargando mapa...</p>
        </div>
      )}
        {coordinates.map(({ id, name, address, coords }) => (
          <Marker key={id} position={[coords.lat, coords.lng]} icon={customIcon}>
            <Popup>
              <div>
                <strong>{name}</strong>
                <br />
                {address}
                <br />
                <a href={'#' + id} onClick={(e) => { e.preventDefault(); handleScrollTo(id); }}>Ver más</a>
              </div>
            </Popup>
          </Marker>
        ))}
      </LeafletMap>
      {/* Sección adicional en la página para los elementos vinculados */}
      <div style={{ padding: '20px' }}>
        {addresses.map((sucur) => (
          <div key={sucur.id} id={sucur.id.toString()}>
            <Sucursal suc={sucur} key={sucur.id * 2} id={sucur.id.toString()} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default MapContainer;
